export default "__VITE_ASSET__84c8d0fe__"